import { render, staticRenderFns } from "./SiteNotificationDialog.vue?vue&type=template&id=5e104c96&scoped=true&"
import script from "./SiteNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./SiteNotificationDialog.vue?vue&type=style&index=0&id=5e104c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e104c96",
  null
  
)

export default component.exports